var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoJira(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.999,
    height: 22.617,
    viewBox: "0 0 21.999 22.617",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#2684ff;}.b{fill:url(#a);}.c{fill:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.918,
    y1: 0.403,
    x2: 0.282,
    y2: 0.816,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.087,
    y1: -0.233,
    x2: 0.722,
    y2: 0.179,
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.993,18.635.263,11.941a.9.9,0,0,1,0-1.266L3.632,7.326,11,0l.949.943,9.787,9.732a.894.894,0,0,1,0,1.272L18.48,15.178l-.114.113L11,22.617Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.4,7.946A5.607,5.607,0,0,1,7.377,0L0,7.322l4.015,3.986Z",
    transform: "translate(3.495)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M3.382,0,0,3.351a5.59,5.59,0,0,1,0,7.957L7.4,3.98Z",
    transform: "translate(10.897 11.308)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoJira);
export default __webpack_public_path__ + "static/media/logo-jira.a0d2348178d8f7a18e4b5406b3cdccf9.svg";
export { ForwardRef as ReactComponent };